import { TransactionReportField } from "src/app/enums/Report/ReportField/TransactionReportField";
import { IReportSortDefinition } from "../Components/IReportSortDefinition";
import { DateRangeParameter } from "./DateRangeParameter";
import { BaseReportParameters } from "./BaseReportParameters";

const localStorageFormParametersProperty = 'TransactionReportParameters';

export class TransactionReportParameters extends BaseReportParameters {
  reportGroup: TransactionReportField;
  posId: number;
  clerkId: number;
  tableNumber: number;
  transactionDateRange: DateRangeParameter;
  sort: IReportSortDefinition[];

  constructor() {
    super(localStorageFormParametersProperty);
  }

  protected getParameters(storedParameters: TransactionReportParameters) {
    this.reportGroup = <TransactionReportField>(storedParameters?.reportGroup ?? TransactionReportField.None);
    this.posId = storedParameters?.posId ?? -1;
    this.clerkId = storedParameters?.clerkId ?? -1;
    this.tableNumber = storedParameters?.tableNumber ?? null;
    this.transactionDateRange = new DateRangeParameter(storedParameters?.transactionDateRange);
  }
}
